import React from 'react'
import CardUI from '../../../widgets/layout/CardUI.js'
import SpinnerComponentUI from '../../common/SpinnerComponentUI.js'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI.js'
import TermSheetScheduleRowCreateModalSF from './TermSheetScheduleRowCreateModalSF.js'
import TermSheetScheduleRowUpdateModalSF from './TermSheetScheduleRowUpdateModalSF.js'
import TermSheetScheduleRowDeleteModalSF from './TermSheetScheduleRowDeleteModalSF.js'
import TermSheetScheduleRefreshModalSF from './TermSheetScheduleRefreshModalSF.js'
import './TermSheetScheduleRows.css'

const TermSheetScheduleRowsUI = ({
  context, loan, title, scheduleRowList,
  createMode, onCreateRowClick, onCreateRowCancel,
  updateMode, selectedRow, onUpdateRowClick, onUpdateRowCancel,
  deleteMode, onDeleteRowClick, onDeleteRowCancel,
  refreshFromMasterMode, onRefreshFromMasterClick, onRefreshFromMasterCancel,
  onRefreshClick,
}) => (
  <>
    <CardUI className='su_ts_sched' title={title}>
      {!scheduleRowList &&
        <div className='empty_state'>
          <SpinnerComponentUI />
        </div>
      }
      {scheduleRowList &&
        <>
          <table className='g_table'>
            <thead>
              <tr>
                <td className='g_text_center col_sno'><b>S.No</b></td>
                <td className='col_particular'><b>Particular</b></td>
                <td className='col_terms'><b>Terms and Conditions</b></td>
                <td className='col_actions' />
              </tr>
            </thead>
            <tbody>
              {scheduleRowList.length === 0 &&
                <tr>
                  <td colSpan='4'>
                    <div className='empty_state'>
                      <div className='empty_msg g_muted'>No schedule rows yet.</div>
                      <ButtonTinyUI label='Add Row' onClick={onCreateRowClick} />
                    </div>
                  </td>
                </tr>
              }
              {scheduleRowList.map((row, index) => (
                <tr key={row.templateId}>
                  <td className='g_text_center g_text_top'>{index + 1}</td>
                  <td className='g_text_top'>
                    <div className='wrap'>{row.particular}</div>
                  </td>
                  <td className='g_text_top'>
                    <div className='wrap' dangerouslySetInnerHTML={{ __html: row.termsAndConditions }} />
                  </td>
                  <td className='g_text_top actions'>
                    <div className='g_flex_h g_flex_right'>
                      <ButtonTinyUI
                        label='Edit'
                        template-id={row.templateId}
                        onClick={onUpdateRowClick}
                      />
                      <ButtonTinyUI
                        label='Delete'
                        template-id={row.templateId}
                        onClick={onDeleteRowClick}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {scheduleRowList.length > 0 &&
                <tr>
                  <td />
                  <td className='add_row_cell'>
                    <ButtonTinyUI label='Add Row' onClick={onCreateRowClick} />
                  </td>
                  <td colSpan='2' />
                </tr>
              }
            </tbody>
          </table>
          {loan.loanId !== 'master'
            && context.permissions.includes('su_superuser_business') &&
            <div className='g_m_top_100 g_text_right'>
              <ButtonTinyUI
                label='Refresh schedule from master'
                onClick={onRefreshFromMasterClick}
              />
            </div>
          }
        </>
      }
    </CardUI>

    <TermSheetScheduleRowCreateModalSF
      context={context}
      loan={loan}
      createMode={createMode}
      onCreateRowCancel={onCreateRowCancel}
      onRefreshClick={onRefreshClick}
    />

    <TermSheetScheduleRowUpdateModalSF
      context={context}
      loan={loan}
      row={selectedRow}
      updateMode={updateMode}
      onUpdateRowCancel={onUpdateRowCancel}
      onRefreshClick={onRefreshClick}
    />

    <TermSheetScheduleRowDeleteModalSF
      context={context}
      loan={loan}
      row={selectedRow}
      deleteMode={deleteMode}
      onDeleteRowCancel={onDeleteRowCancel}
      onRefreshClick={onRefreshClick}
    />

    <TermSheetScheduleRefreshModalSF
      context={context}
      loan={loan}
      isOpen={refreshFromMasterMode}
      onCancel={onRefreshFromMasterCancel}
      onRefreshClick={onRefreshClick}
    />
  </>
)

export default TermSheetScheduleRowsUI
